import React from "react";
import "../../css/sharedStyles.css";
import MoreButton from "../moreButton/MoreButton.js";
import "./SectionComicAppearances.css";

import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import LoaderAnimation from "../loaderAnimation/loaderAnimation.js";

  var SectionComicAppearances = class SectionComicAppearances extends React.Component{
  constructor(props) {
      super(props);
      this.state = {
        counter: 0
      }

  } //end constructor() 


  render() {
    //THESE ARE THE COMICS THAT SHOW UP THAT ARE CONNECTED TO A CHARACTER ON THE CHARACTER PAGE
    const routeBase = localStorage.getItem("routeBase"); 

    if(this.props.characterInfo.comicsAreaReadyToShow === true){ 
        return (
          <div className="SectionComicAppearancesContainer">  
              <div className="SectionComicAppearances">
              {
                //LOOP through and render the comics attached to the selected character 
                //i add index to the key bc its stopping the unique ID error in react. Dont know why
                this.props.characterInfo.comicsArray.map(function(comic,index){                               
                      return <Link to={routeBase + "/comicDetail"} key={index}>
                          <img src={ comic[2]} className="imageBorder"
                              key={index} id={comic[3]} 
                              ref={"comic"+index}
                              onClick = {(id)=>{this.props.changeMainComic(comic) }} //duh
                              alt = {"comic"+index}
                          />
                      </Link> 
              },this)
              }
              </div>
              <MoreButton 
                  margin = {"6px 0 0 6px"}
                  link = {"https://www.google.com/"} 
              />
          </div>
        );//end return()
      }//end if()
      else{
        return(
          <LoaderAnimation text = "Loading Comic Appearances" />
        )
      }    
  }//end render()
  
  
  
  
  
  
  }//end class()

export default SectionComicAppearances;


// WEBPACK FOOTER //
// ./src/components/comicAppearancesArea/SectionComicAppearances.js